import { Col, Icon, Row, Select } from "antd";
import React from "react";
import { useEffect } from "react";
import {Fragment} from "react";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {compose} from "redux";
import Call from "../../../hocs/call";
import { GUTTER_SM, MARGIN_MD, MARGIN_SM} from "../../../styles/constants";
import { EL_STEP_MAPPING, newMapping } from "../constants";
import { getELCsvMappingsCube, readELFileMapping, resetELMapping } from "./actions";
import { EL_MAPPING_NEW_MAPPING, getELMappingTranslations } from "./constants";
import ELMapper from "./ELMapper";
import { getMappingIcon } from "./utils";
 

const mapStateToProps = state => ({
  step: state.scenes.easyLoading.step,
  srcFile: state.scenes.easyLoading.srcFile,
  dstDataflow: state.scenes.easyLoading.dstDataflow,
  mappings: state.scenes.easyLoading.mappings,
  csvHeader: state.scenes.easyLoading.csvHeader,
  cube: state.scenes.easyLoading.cube,
  shouldVerifyMapping: state.scenes.easyLoading.shouldVerifyMapping,
  currentMapping: state.scenes.easyLoading.currentMapping,
  currentMappingIsValid: state.scenes.easyLoading.currentMappingIsValid,
});

const mapDispatchToProps = dispatch => ({
  fetchCsvMappingsCube: ({separator, delimiter, hasHeader, csvPath, cubeId}) =>
    dispatch(getELCsvMappingsCube(separator, delimiter, hasHeader, csvPath, cubeId)),
  clearMapping : () => dispatch(resetELMapping()),
  readMappingDetails: (fileMappingId) => dispatch(readELFileMapping(fileMappingId)), 
});

const LABEL_WIDTH = 100;

const ELMappingStep = ({
  t,
  step,
  srcFile,
  dstDataflow,
  mappings,
  csvHeader,
  cube,
  shouldVerifyMapping,
  currentMappingIsValid,
  currentMapping,

  fetchCsvMappingsCube,
  clearMapping,
  readMappingDetails
}) => {


  const newMappingOption = newMapping;
  newMappingOption.Name = getELMappingTranslations(t)[EL_MAPPING_NEW_MAPPING];
  const mappingOptions = [newMappingOption].concat(mappings || []);

  const onMappingSelect = (mappingId) => {
    if (mappingId === -1) {
      clearMapping();
    } else  {
      readMappingDetails(mappingId);
    }       
  };
  
  useEffect(() => {
    if ((mappings || []).length === 1 && shouldVerifyMapping ) {      
      readMappingDetails(mappings[0].IDMapping);        
    }
  }, [mappings, shouldVerifyMapping, readMappingDetails])

  return ( 
    <Call 
      cb={fetchCsvMappingsCube}
      cbParam={{
        separator: srcFile ? srcFile.separator : null,
        delimiter: (srcFile && srcFile.delimiter) ? srcFile.delimiter : null,
        hasHeader: true,
        csvPath: srcFile ? srcFile.csvPath : null,
        cubeId: dstDataflow.cubeId
      }}
      disabled={ step !== EL_STEP_MAPPING || !srcFile || mappings !== null || csvHeader !== null}
    >      
      <Fragment>
        <Row type="flex" gutter={GUTTER_SM} style={{marginBottom: MARGIN_MD}} align="middle">
          <Col span={17}>
            <div
              style={{
                display: "inline-block",
                width: LABEL_WIDTH
              }}
            >
            {`${t('components.easyLoading.steps.mapping.title')}: `}
            </div>
              <Select
                style={{width: `calc(100% - ${LABEL_WIDTH}px`}}
                onChange={(value) => onMappingSelect(value)}
                value={currentMapping.IDMapping}
              >                      
                {mappingOptions
                .map((mapping, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={mapping.IDMapping}
                    >
                      <Icon type={getMappingIcon(mapping.IDMapping)} style={{marginRight: MARGIN_SM}}/>
                      {mapping.Name}
                    </Select.Option>
                  )
                })}                    
              </Select>
          </Col>
          <Col span={7}>
            {currentMappingIsValid 
            ? <Fragment>
                <Icon type="check-circle" theme="filled" style={{color: 'green'}}/>
                {` ${t('components.easyLoading.steps.mapping.validation.valid')}`}                
              </Fragment>
            : <Fragment>
                <Icon type="close-circle" theme="filled" style={{color: 'red'}}/>
                {` ${t('components.easyLoading.steps.mapping.validation.notValid')}`}                
              </Fragment>}           
          </Col>
      </Row> 
      {csvHeader && cube && (
      <Row gutter={GUTTER_SM}>
        <ELMapper
          csvHeader={csvHeader}
          cube={cube}
          selectedMapping={currentMapping.IDMapping}
        />
      </Row>     
      )}  
      </Fragment> 
    </Call>   
  );
};

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ELMappingStep);



// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/index.jsx